import ReactContentLoader, {
  IContentLoaderProps,
} from "react-content-loader";

const BACKGROUND = "#E0E0E0";
const FOREGROUND = "#C8C8C8";

const ContentLoader = ({
  speed = 2,
  backgroundColor = BACKGROUND,
  foregroundColor = FOREGROUND,
  ...props
}: IContentLoaderProps) => (
  <ReactContentLoader
    speed={speed}
    backgroundColor={backgroundColor}
    foregroundColor={foregroundColor}
    {...props}
  />
);

export default ContentLoader;
export type { IContentLoaderProps };
